import { useEffect, useState } from 'react';
import axios from 'axios';
import { Infinity as InfinityIcon, Sparkles } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AiPlanQuotaBadge({ refreshKey }) {
  const [quota, setQuota] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API}/training/ai/quota`);
        if (!cancelled) setQuota(res.data);
      } catch (e) { /* ignore */ }
    })();
    return () => { cancelled = true; };
  }, [refreshKey]);

  if (!quota) return null;

  if (quota.unlimited) {
    return (
      <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-800 text-xs font-medium" data-testid="ai-plan-quota-badge">
        <InfinityIcon className="w-3.5 h-3.5" /> Unlimited plans this month
      </div>
    );
  }

  const remaining = quota.remaining ?? 0;
  const low = remaining <= 1;
  return (
    <div
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium border ${
        low ? 'bg-amber-50 border-amber-200 text-amber-800' : 'bg-emerald-50 border-emerald-200 text-emerald-800'
      }`}
      data-testid="ai-plan-quota-badge"
    >
      <Sparkles className="w-3.5 h-3.5" />
      <span>
        {remaining} of {quota.limit} {remaining === 1 ? 'generation' : 'generations'} left this month
      </span>
    </div>
  );
}
